import Vue from 'vue';
export const DeleteIcon = Vue.extend({
    functional: true,
    name: 'DeleteIcon',
    render(createElement, ctx) {
        return (<svg viewBox="0 0 50 50">
                <g transform="matrix(1.8776824,0,0,1.8776824,-21.99839,-22.148608)">
                    <path style="fill:#222731" 
        // tslint:disable-next-line: max-line-length
        d="m 25.81,22 h -1.56 v 9.27 h 1.56 z m 3,0 h -1.53 l -0.34,9.26 1.56,0.06 z m -5.72,9.21 -0.31,-9.21 -1.56,0.05 0.34,9.27 z m 5.77,-13.1 v -1.7 a 1.3,1.3 0 0 0 -1.3,-1.3 h -5.09 a 1.3,1.3 0 0 0 -1.3,1.3 v 1.7 h -5.46 v 1.57 h 1.63 l 1.3,14.71 a 0.78,0.78 0 0 0 0.78,0.72 h 11.2 a 0.79,0.79 0 0 0 0.78,-0.72 l 1.29,-14.71 h 1.66 V 18.16 Z M 22.7,16.67 h 4.6 v 1.44 h -4.6 z m 7.2,16.92 H 20.13 L 18.91,19.73 h 12.21 z"/>
                </g>
            </svg>);
    },
});
//# sourceMappingURL=DeleteIcon.jsx.map